import { Button, Flex, Progress, Switch, Td, Tr } from "@chakra-ui/react";
import useToogleFormaPagamento from "core/features/forma-pagamento/hooks/useToogleFormaPagamento";
import useUpdateFormaPagamento from "core/features/forma-pagamento/hooks/useUpdateFormaPagamento";
import { MinhaFormaPagamentoResponse } from "core/features/forma-pagamento/typings";
import { showErrorAxios } from "infra/helpers/alerta";
import { useState } from "react";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import InputMoney from "ui/components/Input/InputMoney";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { MdEdit } from "react-icons/md";

export default function MethodItem({
  tenantId,
  item,
  disableEditTax,
}: {
  tenantId: string;
  item: MinhaFormaPagamentoResponse;
  disableEditTax?: boolean;
}) {
  const { isLoading, mutate: handleToggle } = useToogleFormaPagamento(
    item.id,
    tenantId
  );
  const { isLoading: isLoadingUpdate, mutate: handleUpdate } =
    useUpdateFormaPagamento(item.id, tenantId);

  const [isEdit, setIsEdit] = useState(false);
  const [isChecked, setIsChecked] = useState(item.ativo);
  const [taxaExtra, setTaxaExtra] = useState(item.taxaExtra);

  const getValor = (valor: number) => {
    if (!valor) {
      return "Sem Taxa";
    }

    if (item.tipo === "porcentagem") {
      return `${formatCurrency(Number(valor))}%`;
    }

    return `R$ ${formatCurrency(Number(valor))}`;
  };

  return (
    <Tr pb={2}>
      <Td borderWidth={1} borderRightWidth={0} borderLeftRadius="2xl">
        {isLoading ? (
          <Progress size="sm" isIndeterminate w="100%" colorScheme="cyan" />
        ) : null}

        {!isLoading ? item.nome : null}
      </Td>
      {!disableEditTax ? (
        <Td borderTopWidth={1} borderBottomWidth={1}>
          {isLoading ? (
            <Progress size="sm" isIndeterminate w="100%" colorScheme="cyan" />
          ) : null}

          {!isLoading ? (item.tipo ? getValor(item.taxaPadrao) : "---") : null}
        </Td>
      ) : null}
      {!disableEditTax ? (
        <Td borderTopWidth={1} borderBottomWidth={1}>
          {isLoading ? (
            <Progress size="sm" isIndeterminate w="100%" colorScheme="cyan" />
          ) : null}

          {!isLoading ? (
            item.tipo ? (
              <Flex alignItems={"center"}>
                {!isEdit ? <Flex w="104px">{getValor(taxaExtra)}</Flex> : null}

                {isEdit ? (
                  <InputMoney
                    value={taxaExtra}
                    disabled={isLoadingUpdate}
                    onChange={(ev: any) => setTaxaExtra(ev)}
                    style={{ height: "35px", width: "100px" }}
                  />
                ) : null}

                {isEdit ? (
                  <PrimaryButton
                    isLoading={isLoadingUpdate}
                    isDisabled={isLoadingUpdate}
                    size="sm"
                    ml="8px"
                    mt="2px"
                    onClick={() =>
                      handleUpdate(
                        { taxaExtra },
                        {
                          onSuccess: () => {
                            setIsEdit(false);
                          },
                          onError: (err) => {
                            showErrorAxios(err);
                          },
                        }
                      )
                    }
                  >
                    Salvar
                  </PrimaryButton>
                ) : null}

                {!isEdit ? (
                  <Flex>
                    <Button
                      size="xs"
                      ml="6px"
                      variant="outline"
                      onClick={() => setIsEdit(true)}
                    >
                      <MdEdit />
                      <Flex pl="6px">Editar</Flex>
                    </Button>
                  </Flex>
                ) : null}
              </Flex>
            ) : (
              "---"
            )
          ) : null}
        </Td>
      ) : null}

      {!disableEditTax ? (
        <Td fontWeight={"bold"} borderTopWidth={1} borderBottomWidth={1}>
          {isLoading ? (
            <Progress size="sm" isIndeterminate w="100%" colorScheme="cyan" />
          ) : null}
          {!isLoading
            ? item.tipo
              ? getValor(item.taxaPadrao + taxaExtra)
              : "---"
            : null}
        </Td>
      ) : null}

      <Td borderWidth={1} borderLeftWidth={0} borderRightRadius="2xl">
        <Switch
          isDisabled={isLoading}
          isChecked={isChecked}
          onChange={() => {
            handleToggle(!isChecked, {
              onSuccess: () => {
                setIsChecked((prev) => !prev);
              },
              onError: (err: any) => {
                showErrorAxios(err);
              },
            });
          }}
          size="lg"
        />
      </Td>
    </Tr>
  );
}
